import { render, staticRenderFns } from "./BatchCreateStaff.vue?vue&type=template&id=4a736466&scoped=true&"
import script from "./BatchCreateStaff.vue?vue&type=script&lang=js&"
export * from "./BatchCreateStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a736466",
  null
  
)

export default component.exports